/* Castor Wheels selector. No third-party dependencies; Barn2 still handles discounts. */
(() => {
  const init = (root) => {
    if (root.dataset.cwReady === 'true') return;
    root.dataset.cwReady = 'true';
    const by = (selector) => root.querySelector(selector);
    const all = (selector) => [...root.querySelectorAll(selector)];
    const list = by('[data-cw-items]');
    if (!list) return;
    const rows = all('[data-cw-option]');
    const selectors = all('[data-cw-filter]');
    const money = (pennies) => {
      const amount = Number(pennies) / 100;
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: root.dataset.currency || 'GBP' }).format(amount);
    };
    const sortedUnique = (field) => [...new Set(rows.map(row => row.dataset[field]).filter(Boolean))]
      .sort((a, b) => a.localeCompare(b, 'en-GB', {numeric: true}));
    for (const select of selectors) {
      for (const value of sortedUnique(select.dataset.cwFilter)) {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = value;
        select.append(option);
      }
    }
    const search = by('[data-cw-search]');
    const sort = by('[data-cw-sort]');
    const updateList = () => {
      const term = search.value.trim().toLowerCase();
      let count = 0;
      rows.forEach(row => {
        const matches = (!term || row.dataset.sku.toLowerCase().includes(term)) &&
          selectors.every(select => !select.value || row.dataset[select.dataset.cwFilter] === select.value);
        row.hidden = !matches;
        if (matches) count++;
      });
      const sorter = {
        diameter: (a,b) => parseFloat(a.dataset.diameter) - parseFloat(b.dataset.diameter),
        price: (a,b) => Number(a.dataset.price) - Number(b.dataset.price),
        sku: (a,b) => a.dataset.sku.localeCompare(b.dataset.sku, 'en-GB', {numeric:true}),
        default: (a,b) => Number(a.dataset.index) - Number(b.dataset.index)
      }[sort.value];
      [...rows].sort(sorter).forEach(row => list.appendChild(row));
      by('[data-cw-count]').textContent = `Showing ${count} of ${rows.length} options`;
      by('[data-cw-empty]').hidden = count !== 0;
    };
    selectors.forEach(select => select.addEventListener('change', updateList));
    search.addEventListener('input', updateList);
    sort.addEventListener('change', updateList);
    by('[data-cw-clear]').addEventListener('click', () => {
      search.value = ''; selectors.forEach(select => select.value = ''); sort.value = 'default'; updateList();
    });

    const preview = by('[data-cw-preview]');
    const cartForm = by('[data-cw-cart-form]');
    const qtySelected = by('[data-cw-cart-qty]');
    const addButton = by('[data-cw-add]');
    let chosen = null;
    const choose = (row, scroll = true) => {
      if (!row?.dataset.variantId || row.dataset.available !== 'true') return;
      chosen = row;
      rows.forEach(item => item.classList.toggle('is-selected', item === row));
      by('[data-cw-cart-id]').value = row.dataset.variantId;
      const rowQty = row.querySelector('[data-cw-row-qty]');
      qtySelected.min = row.dataset.min || 1;
      qtySelected.step = row.dataset.step || 1;
      if (row.dataset.max) qtySelected.max = row.dataset.max;
      else qtySelected.removeAttribute('max');
      qtySelected.value = rowQty?.value || row.dataset.min || 1;
      by('[data-cw-sku]').textContent = row.dataset.sku;
      by('[data-cw-summary]').textContent = `${row.dataset.diameter} wheel · ${row.dataset.type} · ${row.dataset.fitting}`;
      by('[data-cw-price]').textContent = `${money(row.dataset.price)} ex VAT`;
      by('[data-cw-availability]').textContent = 'Available to order';
      const img = by('[data-cw-photo]');
      if (row.dataset.image) { img.src = row.dataset.image; img.alt = `${row.dataset.sku} castor`; img.hidden = false; }
      else img.hidden = true;
      const specs = by('[data-cw-specs]');
      specs.replaceChildren(row.querySelector('[data-cw-details]').content.cloneNode(true));
      const tiers = by('[data-cw-tier-list]');
      tiers.replaceChildren(row.querySelector('[data-cw-tiers]').content.cloneNode(true));
      addButton.disabled = false;
      by('[data-cw-feedback]').textContent = '';
      if (scroll && window.matchMedia('(max-width: 1099px)').matches) {
        preview.scrollIntoView({behavior: 'smooth', block: 'start'});
      }
    };
    rows.forEach(row => row.querySelector('[data-cw-select]')?.addEventListener('click', () => choose(row)));
    const initiallySelected = rows.find(row => row.dataset.variantId === new URLSearchParams(location.search).get('variant')) ||
      rows.find(row => row.dataset.available === 'true' && row.dataset.variantId);
    if (initiallySelected) choose(initiallySelected, false);
    updateList();

    const tabs = all('[data-cw-tab]');
    tabs.forEach(tab => tab.addEventListener('click', () => {
      tabs.forEach(other => other.setAttribute('aria-selected', String(other === tab)));
      all('[data-cw-tab-panel]').forEach(panel => { panel.hidden = panel.dataset.cwTabPanel !== tab.dataset.cwTab; });
    }));
    cartForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!chosen) return;
      const qty = Number(qtySelected.value);
      const min = Number(chosen.dataset.min || 1);
      const step = Number(chosen.dataset.step || 1);
      const max = chosen.dataset.max ? Number(chosen.dataset.max) : Infinity;
      const message = by('[data-cw-feedback]');
      if (!Number.isSafeInteger(qty) || qty < min || qty > max || (qty - min) % step !== 0) {
        message.textContent = `Please enter a valid quantity (minimum ${min}${max < Infinity ? `, maximum ${max}` : ''}; increments of ${step}).`;
        qtySelected.focus(); return;
      }
      const rootPath = window.Shopify?.routes?.root || '/';
      const submitUrl = `${rootPath}cart/add.js`;
      addButton.disabled = true;
      message.textContent = 'Adding to basket…';
      try {
        const response = await fetch(submitUrl, {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          credentials: 'same-origin',
          body: JSON.stringify({items: [{id: Number(chosen.dataset.variantId), quantity: qty}]})
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Could not add this product.');
        // Go to the actual Shopify cart so Barn2's applied discounts can be verified.
        window.location.assign(`${rootPath}cart`);
      } catch (error) {
        message.textContent = error.message || 'Unable to add to basket. Please try again.';
        addButton.disabled = false;
      }
    });
  };
  const start = () => document.querySelectorAll('[data-cw-selector]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
